module.exports = __webpack_public_path__ + "img/subscription-icon.bbbc7cf1.svg";